import React from 'react';

/**
 * ErrorScreen — shown when Supabase submission fails.
 * @param {function} onRetry - Callback to retry submission
 */
function ErrorScreen({ onRetry }) {
  const waNumber = process.env.REACT_APP_WHATSAPP_NUMBER || '';
  const waLink = waNumber
    ? `https://wa.me/${waNumber}?text=${encodeURIComponent(
        'Hi, I could not submit the daily outlet report. Please help.'
      )}`
    : null;

  return (
    <div className="error-screen">
      <div className="error-icon" role="img" aria-label="Error">
        ⚠️
      </div>
      <h2 className="error-title">Something went wrong.</h2>
      <p className="error-sub">
        Your report could not be sent. Please try again, or contact your
        manager via WhatsApp.
      </p>
      <div className="error-actions">
        <button className="btn-retry" type="button" onClick={onRetry}>
          Try again
        </button>
        {waLink && (
          <a
            className="btn-whatsapp"
            href={waLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            Message manager on WhatsApp
          </a>
        )}
      </div>
    </div>
  );
}

export default ErrorScreen;
